/* ================================================
   generator.js — Utilitaires partagés
   Générateurs Etam — v2.0.0

   Fonctions modulables, utilisables par tout
   générateur HTML de la suite Etam.
   ================================================ */

'use strict';

/* ------------------------------------------------
   SYNTAX HIGHLIGHTING
   ------------------------------------------------
   Utilise des marqueurs Unicode Private Use Area
   (\uE000–\uE007) pour éviter que les regex ne se
   contaminent entre elles lors du chaînage.
   ------------------------------------------------ */

/**
 * Colorise du HTML brut pour l'affichage dans un <pre>.
 * @param   {string} html  Code HTML brut
 * @returns {string}       HTML avec balises <span> de coloration
 */
function highlight(html) {
    const [C0, C1] = ['\uE000', '\uE001']; // commentaire
    const [T0, T1] = ['\uE002', '\uE003']; // balise
    const [A0, A1] = ['\uE004', '\uE005']; // attribut
    const [V0, V1] = ['\uE006', '\uE007']; // valeur

    return html
        .replace(/&/g,  '&amp;')
        .replace(/</g,  '&lt;')
        .replace(/>/g,  '&gt;')
        .replace(/(&lt;!--[\s\S]*?--&gt;)/g, C0 + '$1' + C1)
        .replace(/(&lt;\/?)([\w-]+)/g,        T0 + '$1$2' + T1)
        .replace(/\s([\w-]+)=/g,             ' ' + A0 + '$1' + A1 + '=')
        .replace(/="([^"]*)"/g,             '="' + V0 + '$1' + V1 + '"')
        .replace(/\/&gt;/g,                   T0 + '/&gt;' + T1)
        .replaceAll(C0, '<span class="hl-cmt">') .replaceAll(C1, '</span>')
        .replaceAll(T0, '<span class="hl-tag">') .replaceAll(T1, '</span>')
        .replaceAll(A0, '<span class="hl-attr">').replaceAll(A1, '</span>')
        .replaceAll(V0, '<span class="hl-val">') .replaceAll(V1, '</span>');
}

/* ------------------------------------------------
   SLIDERS
   ------------------------------------------------ */

/**
 * Connecte un input[type=range] à son affichage textuel.
 * @param {string}   sliderId  ID de l'input range
 * @param {string}   valueId   ID de l'élément d'affichage
 * @param {string}   suffix    Suffixe affiché (ex: '%', 'ms')
 * @param {Function} [onUpdate] Callback après chaque changement
 */
function bindSlider(sliderId, valueId, suffix, onUpdate) {
    const slider  = document.getElementById(sliderId);
    const display = document.getElementById(valueId);
    slider.addEventListener('input', function () {
        display.textContent = slider.value + suffix;
        if (typeof onUpdate === 'function') onUpdate();
    });
}

/* ------------------------------------------------
   TABS
   ------------------------------------------------ */

/**
 * Bascule l'onglet actif.
 * Convention d'ID : le panneau doit avoir l'id `pane-{name}`.
 * @param {string}      name  Identifiant de l'onglet
 * @param {HTMLElement} btn   Le bouton cliqué
 */
function switchTab(name, btn) {
    document.querySelectorAll('.gen-tabs__btn')
        .forEach(function (b) { b.classList.remove('gen-tabs__btn--active'); });
    document.querySelectorAll('.gen-tabs__pane')
        .forEach(function (p) { p.classList.remove('gen-tabs__pane--active'); });
    btn.classList.add('gen-tabs__btn--active');
    document.getElementById('pane-' + name).classList.add('gen-tabs__pane--active');
}

/* ------------------------------------------------
   VIEWPORT
   ------------------------------------------------ */

/**
 * Bascule le viewport de prévisualisation (mobile / desktop).
 * Appelle window.onViewportChange(mode) si défini, puis window.update().
 * @param {string}      mode  'mobile' | 'desktop'
 * @param {HTMLElement} btn   Le bouton cliqué
 */
function setViewport(mode, btn) {
    document.querySelectorAll('.preview__viewport-btn')
        .forEach(function (b) { b.classList.remove('preview__viewport-btn--active'); });
    btn.classList.add('preview__viewport-btn--active');

    var frame = document.getElementById('previewFrame');
    frame.classList.toggle('preview__frame--mobile',  mode === 'mobile');
    frame.classList.toggle('preview__frame--desktop', mode === 'desktop');

    if (typeof window.onViewportChange === 'function') window.onViewportChange(mode);
    if (typeof window.update === 'function') window.update();
}

/* ------------------------------------------------
   ID ALÉATOIRE
   ------------------------------------------------ */

/**
 * Génère et insère un ID aléatoire dans un champ texte.
 * @param {string} fieldId        ID du champ input
 * @param {string} [prefix]       Préfixe (défaut : 'unique-id-')
 */
function initRandomId(fieldId, prefix) {
    var p = (prefix !== undefined) ? prefix : 'unique-id-';
    document.getElementById(fieldId).value = p + Math.floor(Math.random() * 10000 + 1);
}

/* ------------------------------------------------
   COPIER LE CODE
   ------------------------------------------------ */

/**
 * Configure le bouton "Copier le code" et expose window.copyCode().
 * @param {string}   btnId    ID du bouton
 * @param {Function} getCode  Fonction retournant le code à copier
 */
function initCopyBtn(btnId, getCode) {
    window.copyCode = function () {
        navigator.clipboard.writeText(getCode()).then(function () {
            var btn  = document.getElementById(btnId);
            var orig = btn.textContent;
            btn.textContent = '✓ Copié !';
            btn.classList.add('is-copied');
            setTimeout(function () {
                btn.textContent = orig;
                btn.classList.remove('is-copied');
            }, 2000);
        });
    };
}

/* ------------------------------------------------
   EXPOSITIONS GLOBALES
   Toutes les fonctions utilitaires doivent être
   exposées sur window : le bundler (Parcel/Vite)
   encapsule les modules — les scripts inline dans
   le HTML ne peuvent pas accéder au scope du module.
   ------------------------------------------------ */
window.highlight    = highlight;
window.bindSlider   = bindSlider;
window.initRandomId = initRandomId;
window.initCopyBtn  = initCopyBtn;
window.switchTab    = switchTab;
window.setViewport  = setViewport;
